/** Tema: automático (segue o sistema), claro ou escuro; a escolha fica no navegador da pessoa. */
export type Theme = 'auto' | 'light' | 'dark';
const KEY = 'pmis.theme';

export function getTheme(): Theme {
  try { return (localStorage.getItem(KEY) as Theme) || 'auto'; } catch { return 'auto'; }
}

export function applyTheme(t: Theme = getTheme()) {
  const root = document.documentElement;
  if (t === 'auto') root.removeAttribute('data-theme');
  else root.setAttribute('data-theme', t);
}

export function setTheme(t: Theme) {
  try { localStorage.setItem(KEY, t); } catch { /* sem armazenamento: vale só nesta aba */ }
  applyTheme(t);
}
